import axios from 'axios'
import settings from '../config/settings'
const { CUBE_API_URL } = settings

const getCubeData = (payload) => {
    var instance = axios.create();
    delete instance.defaults.headers.common['accessToken'];
    return instance.post(`${CUBE_API_URL}/cubejs-api/v1/load`,payload,{
      headers: {
            'Authorization': localStorage.getItem('cubeToken')
      }
    })
} 
export const mergeReportsDataMaster = async (queryObj,mergeReport) => {
    let result = await queryExecutor(queryObj);
    for (const report of mergeReport || []) {
      const filters = handleFilterFromJoinConfig(result, report?.joinConfiguration);
      const queries = queryMaker(report, filters);
      const result2 = await queryExecutor(queries);
      const mergedResult = merger(result, result2, report?.joinConfiguration, report?.groupConfiguration || {});
      result = mergedResult;
    }
    return result
  };

  const queryMaker = (mergeReport,filters) => {
    let query = {
      measures: mergeReport?.selectedFields?.secondaryReport?.filter(field => field.keyType === 'measure').map(field => field.fieldName),
      dimensions: mergeReport?.selectedFields?.secondaryReport?.filter(field => field.keyType === 'dimension').map(field => field.fieldName),
      filters: filters,
      limit: 50000,
      offset: 0,
      timezone: "UTC",
      total: true
    }
    return query
  }

  const queryExecutor = async (query) => {
    const result = await getCubeData({query:query})
    return result.data.data
  }

  const merger = (leftArr, rightArr, joinConfiguration, groupConfiguration) => {
    const allRightKeys = new Set();
    rightArr.forEach(obj => {
      Object.keys(obj).forEach(key => allRightKeys.add(key));
    });
  
    return leftArr.map(leftItem => {
      const matches = rightArr.filter(rightItem =>
        joinConfiguration.every(({ leftField, rightField }) =>
          leftItem[leftField.fieldName] === rightItem[rightField.fieldName]
        )
      );      
      const rightData = aggregateArray(matches, groupConfiguration);
      return {
        ...leftItem,
        ...rightData
      };
    });
  }
  
  const handleFilterFromJoinConfig = (firstQueryResult, joinConfiguration) => {
    const filters = [];
  
    joinConfiguration.forEach(({ leftField, rightField }) => {
      const leftFieldName = leftField.fieldName; 
      const rightFieldName = rightField.fieldName; 
  
      const values = Array.from(
        new Set(
          firstQueryResult
            .map(item => item[leftFieldName])
            .filter(val => val !== undefined && val !== null)
        )
      );
  
      filters.push({
        member: rightFieldName,
        operator: "equals",
        values: values
      });
    });
  
    return filters;
  }

  const operations = {
    CSV: (values) => values.join(","),
    SUM: (values) => values.reduce((acc, val) => acc + val, 0),
    MIN: (values) => Math.min(...values),
    MAX: (values) => Math.max(...values),
    AVG: (values) => values.reduce((acc, val) => acc + val, 0) / values.length,
    COUNT: (values) => values.length,
    COUNT_DISTINCT: (values) => new Set(values).size,
  };

  const aggregateArray = (arr, config)=> {
    if (!arr.length) return {};
  
    const result = {};
    const allKeys = new Set(arr.flatMap(obj => Object.keys(obj)));
  
    for (const key of allKeys) {
      const values = arr.map(item => item[key]);

      if(!values.length) result[key] = "NA";
      else if (config[key] && operations[config[key]]) {
        result[key] = operations[config[key]](values);
      } else {
        result[key] = values[0];
      }
    }
  
    return result;
  }
  